import { compact } from '../../../../helpers/compact';
import {
  DisclaimerSlice,
  LaPosteEn4Type,
} from '../../../../types/LaPosteEn4/slice';
import { toRichText } from '../../fields/text';
const disclaimerSlice = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): DisclaimerSlice | undefined => {
  const description = toRichText(data.primary?.description);
  if (!description) {
    return undefined;
  }

  return compact({
    type: LaPosteEn4Type.DISCLAIMER,
    description,
  });
};

export default disclaimerSlice;
